<script setup lang="ts">
import type { IconName, IconPrefix } from '~/types';

const props = withDefaults(
  defineProps<{
    name: IconName;
    filled?: boolean;
    prefix?: IconPrefix;
    mode?: 'svg' | 'css';
    strokeColor?: string;
    fillColor?: string;
    iconOpacity?: number;
    animationDuration?: string;
    size?: string;
  }>(),
  {
    prefix: 'icons',
    mode: 'svg',
    strokeColor: 'black',
    fillColor: 'transparent',
    iconOpacity: 1,
    animationDuration: '1s',
    size: '24px',
  },
);

const customize = (content: string) => {
  return content
    .replace(/stroke="[^"]*"/g, `stroke="${props.strokeColor}"`)
    .replace(/fill="[^"]*"/g, `fill="${props.fillColor}"`)
    .replace(/animation-duration="[^"]*"/g, `animation-duration="${props.animationDuration}"`)
    .replace(/opacity="[^"]*"/g, `opacity="${props.iconOpacity}"`);
};
</script>

<template>
  <span class="flex justify-center">
    <Icon
      :name="`${prefix}:${name}`"
      :filled="filled"
      :size="size"
      :mode="mode"
      :customize="customize"
    />
  </span>
</template>
